<template>
  <div>
    <div class="ibox mx-2">
      <div class="ibox-title">
        Doc Hub
      </div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-sm-3" v-for="page in pages" :key="page.name">
            <router-link tag="div" :to="`/admin/doc-hub/${page.path}`" class="card card-admin">
              <div class="card-body text-center">
                <strong>
                  {{ page.name }}
                </strong>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    pages: [
      { name: 'Eventos', path: 'events' },
      { name: 'Orders', path: 'orders' },
      { name: 'Items', path: 'items' }
    ]
  }),
  name: 'Index',
}
</script>

<style scoped>
  .card-admin {
    cursor: pointer;
  }
  .card-admin:hover {
    transition: background-color 1s;
    background: #8080803d;
  }
</style>
